import { blue, green, indigo, purple } from "./colors";

export const getPrimary = (preset) => {
  switch (preset) {
  case "blue":
    return blue;
  case "green":
    return green;
  case "indigo":
    return indigo;
  case "purple":
    return purple;
  default:
    console.error('Invalid color preset, accepted values: "blue", "green", "indigo" or "purple"".');
    return blue;
  }
};

// Utility function to check if a color is close to white
export const isLightColor = (hexColor) => {
  if (!hexColor) return false;

  // Remove # if present
  const color = hexColor.startsWith("#") ? hexColor.substring(1) : hexColor;

  // Handle 3-digit hex
  const hex = color.length === 3
    ? color.split("").map(c => c + c).join("")
    : color;

  // Convert hex to RGB
  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;

  // Calculate luminance using WCAG formula
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  // Consider colors with luminance > 0.85 as "close to white"
  return luminance > 0.85;
};
